import { render, staticRenderFns } from "./BandejaDoctorHallazgo.vue?vue&type=template&id=2ac5bc62"
import script from "./BandejaDoctorHallazgo.vue?vue&type=script&lang=js"
export * from "./BandejaDoctorHallazgo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports